"use client";
import React from 'react';
import OngoingOrders from './OngoingOrders';

const ProfileOrders = () => {
  const handleOrderClick = (order) => {
    console.log('Order clicked:', order);
    // Navigate to order details or show modal
  };

  return <OngoingOrders onOrderClick={handleOrderClick} />;
};

export default ProfileOrders;
